
import React, { useState } from "react";
import { useEffect } from "react";
import Auth from "./Auth";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
const AuthConsider=()=>{
const { makeApiRequest } = useApiRequest();
const [loader,setLoader]=useState(false)
const [orderData,setOrderData]=useState()
const [mobileNo,setMobileNo]=useState(null)
  const [authLoading, setAuthLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isOTPScreen, setIsOTPScreen] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const generatedUUID = uuidv4();
useEffect(()=>{
    ReedemationAuth()
}
,[])

  const ReedemationAuth = (e, index, slot_id, currentCount, operation) => {
     setLoader(true)
   
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const now = new Date();
    const to = now.toISOString().slice(0, 19).replace("T", " ");
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    const from = lastMonth.toISOString().slice(0, 19).replace("T", " ");

 

   

    makeApiRequest({
        url: `https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/pre-login/order/78FEC9D35F024CF4
`,
      method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
 
      handleSuccess: (res) => handleResponseReedemationAuth(res),
      handleError: handleErrorReedemationAuth,
    });
  };

const handleResponseReedemationAuth=(res)=>{
     setLoader(false)
  console.log("payment option",res.data.data)
  setOrderData(res.data.data)


}
const handleErrorReedemationAuth=()=>{
setLoader(false)
}

  // Handle mobile authentication
  const handleAuthenticate = () => {
     localStorage.setItem("uuid",generatedUUID)
    if (isButtonDisabled) return;
    //setAuthLoading(true);

    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/authenticate",
      method: "POST",
      data: { request: { mobileNo } },
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "x-device-id": localStorage.getItem("uuid") || "",
      },
      onSuccessKey: "authenticateUser",
      onErrorKey: "authenticateUser",
      handleSuccess: (res) => {
        const reqId = res?.data?.response?.requestId;
        //console.log("res",res.data)
        if (reqId) setRequestId(reqId);
        setIsOTPScreen(true);
        setAuthLoading(false);
      },
      handleError: (err) => {
        //console.error("Auth Error:", err);
        setAuthLoading(false);
      },
    });
  };

  // Handle OTP verification
  const handleSubmitOtp = (otp) => {
    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/login",
      method: "POST",
      data: { request: { mobileNo, requestId, otp } },
      headers: {
        "x-app-platform": "web",
          "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid") || "",
         "guest-cart-id": localStorage.getItem("card_id") || ""

      },
      onSuccessKey: "otp",
      onErrorKey: "otp",
      handleSuccess: (res) => {
        if(
          res?.data?.status=="FAILURE"
        ){
           toast.error(res?.data?.statusMessage);
        }
        
        
        //console.log("OTP ",res.data.successful==false)
        if(res.data.successful=="false"){
           toast.error(res.data.statusMessage);
           return 
        }
        if (res.data.successful) {
          localStorage.removeItem("Guest_clientId");
          toast.success("OTP verified successfully!", { autoClose: 1500 });

          localStorage.setItem("UserJWTAuth",res?.data?.response?.jwt)
           localStorage.setItem("referCode",res?.data?.response?.referCode)
           localStorage.setItem("UserId",res?.data?.response?.userId)
            localStorage.setItem("defaultPgId",2)
            localStorage.setItem("defaultPgName","R_UPI")
            localStorage.removeItem("google_jwt")
            
            
          
     /*   
           if(route) {
            // console.log("-----------------")
            localStorage.removeItem("Guest_clientId")
            localStorage.removeItem("Guest_OauthToken")
            const params = new URLSearchParams(location.search);

            const route = params.get("route");       
            const machineId = params.get("machineId"); 

          
            if(machineId){           
              navigate(`/${route}?machineId=${machineId}`)
            }
             navigate(`/${route}`)
          } */
       }
    /*    if(route==null){
        //console.log("-----------------")
        navigate('/')
       } */

      },
      handleError: (err) => {
        toast.error(err?.message || "OTP verification failed");
      },
    });
  };
 useEffect(() => {
    setIsButtonDisabled(!/^\d{10}$/.test(mobileNo));
  }, [mobileNo]);

  
  const handleKeyPress = (e) => {
    // Block non-numeric typing
    if (!/[0-9]/.test(e.key)) {
  e.preventDefault();
    }
  };

const handleChange = (e) => {
    // Remove non-numeric characters
    let value = e.target.value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    setMobileNo(value);
  };


    return(<>
    
    <Auth  resendCode={handleAuthenticate} orderData={orderData}  mobileNo={ mobileNo} handleKeyPress={handleKeyPress} handleChange={handleChange} handleAuthenticate={handleAuthenticate} handleSubmitOtp={handleSubmitOtp} isButtonDisabled={isButtonDisabled} isOTPScreen={isOTPScreen} setIsOTPScreen={setIsOTPScreen} />
    </>)

}
export default AuthConsider;